import {Injectable} from '@angular/core';

import {LoginDialogComponent} from '../widget/login/login-dialog.component';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Router} from '@angular/router';

@Injectable({
    providedIn: 'root'
})

export class LoginDialogService {
    private isOpen = false;

    constructor(
        private dialog: MatDialog,
        private router: Router,
    ) {
    }

    open(options: { referer?: string, callback?: () => any } = {}): MatDialogRef<LoginDialogComponent> {
        // Évite à la popup de s'ouvrir plusieurs fois
        if (this.isOpen) {
            return;
        }

        this.isOpen = true;

        const modalRef = this.dialog.open(LoginDialogComponent, {disableClose: true});

        modalRef.afterClosed().subscribe(
            () => {
                this.isOpen = false;
                const referer = options.referer;
                const callback = options.callback;
                if (!!referer) {
                    if (referer.startsWith('http')) {
                        window.location.href = referer;
                    } else {
                        this.router.navigateByUrl(referer);
                    }
                }
                if (!!callback && typeof callback === 'function') {
                    callback();
                }
            },
            () => {
                this.isOpen = false;
            });

        return modalRef;
    }
}
